import { useProgressiveCount } from 'plataforma-fundacao-componentes';
import { useEffect } from 'react';
import './ProgressBar.scss';
const rootClassName = 'progress-bar';

export interface ProgressBarProps {
  title: string;
  percent: number;
  textPercent?: string;
  leftValue: number;
  rightValue?: number;
  leftText?: string;
  rightText?: string;
  hideDescription?: boolean;
}

export default function ProgressBar(props: ProgressBarProps) {
  const [percent, setPercent] = useProgressiveCount(props.percent);
  const [leftValue, setLeftValue] = useProgressiveCount(props.leftValue);
  const [rightValue, setRightValue] = useProgressiveCount(props.rightValue);

  useEffect(() => {
    setPercent(props.percent);
    setLeftValue(props.leftValue);
    setRightValue(props.rightValue!);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props]);

  return (
    <div className={`${rootClassName}-wrapper`}>
      <div className={`${rootClassName}-header`}>
        <p className={`${rootClassName}-title`}>{props.title}</p>
        <div className={`${rootClassName}-percent-container`}>
          {props.textPercent && (
            <span className={`${rootClassName}-span-text`}>
              {props.textPercent} •{' '}
            </span>
          )}
          <p>{percent}%</p>
        </div>
      </div>
      <div className={`${rootClassName}-fill`}>
        <div
          className={`${rootClassName}-filled`}
          style={{ width: `${percent}%` }}
        />
      </div>
      {!props.hideDescription && (
        <div className={`${rootClassName}-bottom`}>
          <span>
            <p>{leftValue}</p>
            {props.leftText && <p>{props.leftText}</p>}
          </span>
          <span>
            <p>{rightValue}</p>
            {props.rightText && <p>{props.rightText}</p>}
          </span>
        </div>
      )}
    </div>
  );
}
